import { Dispatch } from 'react';

import { CreateContactData } from '@/helpers/hubspot/types';
import logError from '@/helpers/logError';

import { ReplaceInPersonFormState } from '../constants';
import { ReplaceInPersonFormActionMap } from '../reducer';

import { ContactInfoStepActions } from '../steps/ContactInfoStep/state';

export const getContact = async (
	state: ReplaceInPersonFormState,
	dispatch: Dispatch<ReplaceInPersonFormActionMap>,
) => {
	const createContactBody: CreateContactData = {
		email: state.email,
		firstName: state.firstName,
		lastName: state.lastName,
		phone: state.phone,
	};

	const response = await fetch('/api/hubspot/contact', {
		method: 'POST',
		body: JSON.stringify(createContactBody),
	});

	const data = await response.json();

	if (data.hubspotErrorCode === 'INVALID_EMAIL') {
		throw new Error(
			'Invalid email. Please check the email address provided and try again.',
		);
	}

	if (!data || !data.id) {
		logError(new Error('Failed to create HubSpot contact'));
		return null;
	}

	const hubspotContactId = data.id;

	dispatch({
		type: ContactInfoStepActions.SET_HUBSPOT_CONTACT_ID,
		payload: hubspotContactId,
	});

	return hubspotContactId;
};
